'use strict'

import {promiseAllScripts, getUnloadedScripts} from './helpers/scriptLoader'

/**
 * Lazyloads wishlist scripts
 * @param [callback]
 */
export function initWishlist(callback){
    if('requestIdleCallback' in window){
        window.requestIdleCallback(function(){
            return promiseAllScripts(getUnloadedScripts('.js-async-wishlist'), callback);
        })
    }
    else {
        window.addEventListener('load', function(){
            return promiseAllScripts(getUnloadedScripts('.js-async-wishlist'), callback);
        })
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/performance/wishlist.js